import { render, staticRenderFns } from "./AccountsVotingRegistrationStatus.vue?vue&type=template&id=fdfe9052&"
import script from "./AccountsVotingRegistrationStatus.vue?vue&type=script&lang=js&"
export * from "./AccountsVotingRegistrationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports